import { Home09Icon, FileAddIcon, UserCircleIcon, Settings01Icon } from '@hugeicons/core-free-icons';

export const clientNav = [
    {
        icon: Home09Icon,
        path: '/',
        active: '',
        text: 'Dashboard',
    },
    {
        icon: FileAddIcon,
        path: '/loans',
        active: 'loans',
        text: 'Apply for Loan',
    },
    {
        icon: UserCircleIcon,
        path: '/profile',
        active: 'profile',
        text: 'Profile',
    },
];

export const clientNavBottom = [
    {
        icon: Settings01Icon,
        path: '/settings',
        active: 'settings',
        text: 'Settings',
    },
];
